import React, { useState } from 'react';
import classNames from 'classnames';

/* Validation */
import { Formik } from 'formik';
import validationSchema from './formConfig';

/* Gjensidige Core 20 Imports */
import utils from '@gjensidige/core-utilities-css';

/* Gjensidige Core 30 Imports */
import { Alert } from '@gjensidige/core-components/lib/alerts/default';
import { Col, Container, Row } from '@gjensidige/nci-core-grid';
import { Input } from '@gjensidige/core-components/lib/forms/input';
import { Text, Title } from '@gjensidige/nci-core-typography';

/* API */
import axios from 'axios';
import Endpoints from '@internal/common';
import {Button} from "@gjensidige/core-components/lib/button";

const HyundaiLeads = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(false);

  const sendFormData = () => {
    setApiError(false);
    axios
      .post(Endpoints.HyundaiLeads, formData)
      .then(() => setSubmitted(true))
      .catch(() => setApiError(true));
  };

  return (
    <Container className={utils['mt-2']}>
      {submitted ? (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="success"
            showIcon
            style={{ whiteSpace: 'pre-line' }}
            title="Tak for din henvendelse"
            text="Vi kontakter dig hurtigst muligt med et uforpligtende tilbud.
          Vi glæder os til at tale med dig!"
            className={utils['mb-3']}
          />
        </Row>
      ) : (
        <Formik
          enableReinitialize
          initialValues={{
            name: formData.name,
            phoneNumber: formData.phoneNumber
          }}
          validationSchema={validationSchema()}
          onSubmit={() => {
            sendFormData();
          }}
        >
          {(props) => {
            const {
              handleSubmit,
              handleBlur,
              setFieldValue,
              touched,
              errors
            } = props;
            return (
              <form onSubmit={handleSubmit} className={utils['pb-3']}>
                <Row
                  className={classNames(
                    utils['mb-3'],
                    utils['justify-content-center']
                  )}
                >
                  <Col lg={6}>
                    <Title tag="h4">
                      Få et uforpligtende tilbud på forsikring til din bil​
                    </Title>
                    <Text size="p">
                      Udfyld dine informationer i formularen, så kontakter en af
                      vores dygtige rådgivere dig med et uforpligtende tilbud.
                    </Text>
                  </Col>
                </Row>
                <Row className={utils['justify-content-center']}>
                  <Col lg={6}>
                    <Input
                      id="name"
                      labelText="Dit navn"
                      name="name"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('name', event.target.value);
                        setFormData({ ...formData, name: event.target.value });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.name && errors.name)}
                      errorText={errors.name}
                      value={formData.name}
                    />
                    <Input
                      id="phone-number"
                      labelText="Dit telefonnummer *"
                      name="phoneNumber"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('phoneNumber', event.target.value);
                        setFormData({
                          ...formData,
                          phoneNumber: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.phoneNumber && errors.phoneNumber)}
                      errorText={errors.phoneNumber}
                      value={formData.phoneNumber}
                    />
                    <Button variant={'primary'} type="submit" flexible>
                      Send
                    </Button>
                  </Col>
                </Row>
              </form>
            );
          }}
        </Formik>
      )}
      {apiError && (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="error"
            showIcon
            text="Der skete en fejl ved indsendelse. Prøv venligst igen senere"
            title="Der skete en fejl."
            className={utils['mb-3']}
          />
        </Row>
      )}
    </Container>
  );
};

export default HyundaiLeads;
